import { create } from "zustand";

const createFiltersState = (overrides = {}) => ({
    solapa: null,
    search: "",
    fechaAltaDesde: null,
    fechaAltaHasta: null,
    fechaDebitoDesde: null,
    fechaDebitoHasta: null,
    coincidenciaDesde: null,
    coincidenciaHasta: null,
    jurisdiccion: null,
    ...overrides,
});

export const useMatchingJudicialFiltersStore = create((set, get) => ({
    filters: createFiltersState(),
    pagination: { page: 1, pageSize: 10 },
    sortConfig: { key: null, direction: '' },
    initialized: false,

    initialize: (overrides = {}) => {
        const nextFilters = createFiltersState(overrides.filters);
        const nextPagination = {
            page: overrides.pagination?.page ?? 1,
            pageSize: overrides.pagination?.pageSize ?? get().pagination.pageSize,
        };
        const nextSortConfig = overrides.sortConfig ?? { key: null, direction: '' };

        set({
            filters: nextFilters,
            pagination: nextPagination,
            sortConfig: nextSortConfig,
            initialized: true,
        });
    },

    setFilters: (partial) =>
        set((state) => ({
            filters: createFiltersState({ ...state.filters, ...partial }),
            pagination: { ...state.pagination, page: 1 },
        })),

    setFilter: (key, value) =>
        set((state) => ({
            filters: createFiltersState({
                ...state.filters,
                [key]: key === "search" ? (value ?? "") : (value ?? null),
            }),
            pagination: { ...state.pagination, page: 1 },
        })),

    clearFilter: (key) =>
        set((state) => {
            const nextFilters = { ...state.filters };
            if (key in nextFilters) {
                nextFilters[key] = key === "search" ? "" : null;
            }
            return {
                filters: createFiltersState(nextFilters),
                pagination: { ...state.pagination, page: 1 },
            };
        }),

    resetFilters: () =>
        set((state) => ({
            filters: createFiltersState(),
            pagination: { ...state.pagination, page: 1 },
        })),

    setPagination: ({ page, pageSize }) =>
        set((state) => ({
            pagination: {
                page: page ?? state.pagination.page,
                pageSize: pageSize ?? state.pagination.pageSize,
            },
        })),

    setSortConfig: (sortConfig) =>
        set(() => ({
            sortConfig,
        })),
}));
